import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocalStorage } from 'react-use';
import AdminEvaluationAnswerInput from '../Widget/Evaluation/Admin/Input.js';
import AdminEvaluationAnswerFormula from '../Widget/Evaluation/Admin/Formula.js';
import AdminEvaluationAnswerTable from '../Widget/Evaluation/Admin/Table.js';
import {Loading} from 'components/Loading/loading';
import { useParams, useHistory } from 'react-router-dom';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import natsort from 'hooks/natsort.js';
import {
  Breadcrumb,
  Card,
  Col,
  Container,
  Row,
} from 'react-bootstrap';

function Admin() {

	const { formId } = useParams();
  const [auth] = useLocalStorage('authenticated');

  const history = useHistory();
  const [schedule, setSchedule] = useState();
	const [scheduleId, setScheduleId] = useState();
  const [criteria, setCriteria] = useState();
  const [answers, setAnswers] = useState([]);
  const [scores, setScores] = useState([]);
  const [swal, setSwal] = useAlert(null);

	const fetchForm = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}forms/${formId}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: 'criteria,answers.answerAttachments,answers.question,schedule.instrument.score.scoreIndices,schedule.auditee.department',
        }
      });

      setSchedule(response.data.schedule);
      setScheduleId(response.data.SCHEDULE_ID);
      setCriteria(response.data.criteria);
      setAnswers(response.data.answers.sort((a, b) => natsort(a.question.QUESTION_CODE, b.question.QUESTION_CODE)));
      setScores(response.data.schedule.instrument.score.scoreIndices);

    } catch (error) {
      setSwal(error);
      console.log(error);
    }
  }

	useEffect(() => {
		fetchForm();
    const body = document.querySelector('#root');

    body.scrollIntoView({
        behavior: 'smooth'
    }, 200)
	}, []);

	return (
    <Container fluid>
      <Breadcrumb>
        {/* <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
          Audit
        </Breadcrumb.Item> */}
        <Breadcrumb.Item onClick={() => history.push(`/admin/schedules`)}>
          Audit
        </Breadcrumb.Item>
        <Breadcrumb.Item onClick={() => history.push(`/admin/audits/${schedule.SCHEDULE_ID}/evaluations`)}>
          { schedule && schedule.auditee.department.DEPT_NAME}
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Desk Evaluation
        </Breadcrumb.Item>
      </Breadcrumb>
      {!criteria && <Loading />}

			{criteria && (
				<Row>
					<Col md="12">
						<Card>
							<Card.Header>
                <Card.Title style={{fontWeight:'bold'}} as="h3">{criteria.CRITERIA_CODE}. {criteria.CRITERIA_LABEL}</Card.Title>
							</Card.Header>
							<Card.Body>
                <div style={{whiteSpace: 'pre-wrap', fontSize:'17px'}} dangerouslySetInnerHTML={{__html: criteria.CRITERIA_DESCRIPTION}} />
								</Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			{answers && scheduleId && answers.map((answer, key) => {
        switch (answer.question.QUESTION_TYPE_ID) {
          case 1:
            return <AdminEvaluationAnswerInput key={key} scores={scores} answer={answer} />;
          case 2:
            return <AdminEvaluationAnswerFormula key={key} scores={scores} answer={answer} />;
          case 3:
            return <AdminEvaluationAnswerTable key={key} scores={scores} answer={answer} />;
        }
      })}
    </Container>
  );
}


export default Admin;